module.exports = __webpack_public_path__ + "media/payments/downgrade-year-a4121649.png";